import { forwardRef, type ReactNode } from 'react';
import { Button, type ButtonProps } from './button';

export interface IconButtonProps extends Omit<
  ButtonProps,
  'leftIcon' | 'rightIcon' | 'children' | 'size'
> {
  icon: ReactNode;
  'aria-label': string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeMap = {
  sm: 'icon-sm',
  md: 'icon',
  lg: 'icon-lg',
} as const;

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon, size = 'md', ...props }, ref) => (
    <Button ref={ref} size={sizeMap[size]} {...props}>
      {icon}
    </Button>
  ),
);

IconButton.displayName = 'IconButton';
